<template>
  <div class="product-info">
    <div class="image-wrapper">
      <img width="64" :src="productInfo.imageUrl" />
    </div>
    <div class="content-wrapper">
      <div class="title" :class="{isClickable}">{{ productInfo.title }}</div>
      <div class="product-code">
        <div v-if="productInfo.productCode" class="code">
          <span>Ürün Kodu:</span>
          <span>{{ productInfo.productCode }}</span>
        </div>
        <div v-if="productInfo.stockCode" class="code">
          <span>Stok Kodu:</span>
          <span>{{ productInfo.stockCode }}</span>
        </div>
        <div v-if="productInfo.commissionRate" class="code">
          <span>Komisyon Oranı:</span>
          <span>%{{ productInfo.commissionRate }}</span>
        </div>
        <div v-if="productInfo.commission" class="code">
          <span>Komisyon Tutarı:</span>
          <span>{{ productInfo.commission }} TL</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductInfoCell',
  props: {
    productInfo: {
      type: Object,
      required: true,
    },
    isClickable: {
      type: Boolean,
      required: false,
    }
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

.product-info {
  gap: 8px;
  display: flex;
  align-items: center;
  height: 66px;

  .image-wrapper {
    width: 64px;
    min-width: 64px;
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    border: 0.5px solid $colorD40;
    overflow: hidden;

    img {
      max-width: 100%;
      max-height: 100%;
      width: fit-content;
    }
  }

  .content-wrapper {
    height: 100%;
    width: 100%;

    .title {
      width: auto;
      min-height: 32px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 12px;
      font-weight: 600;
      line-height: 16px;
      margin-bottom: 4px;
      color: $colorN80;

      &.isClickable {
        color: $colorN80;
        cursor: pointer;
      }
    }

    .product-code {
      gap: 2px;
      display: flex;
      flex-direction: column;

      .code {
        gap: 4px;
        display: flex;

        > span {
          font-size: 11px;
          line-height: 14px;

          &:first-child {
            font-weight: 600;
            color: $colorD40;
          }

          &:last-child {
            font-weight: 400;
            color: $colorN80;
          }
        }
      }
    }
  }

  &.hunt {
    margin: unset;

    .content-wrapper {
      .title {
        max-width: 224px;
        text-decoration: none;
        color: $colorN80;
      }
    }
  }
}
</style>
